import React, { useEffect, useState } from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import { announcementsPublicApi } from '../../api/adminApi';
import {
  announcementId,
  announcementBody,
  announcementDateInputValue,
  formatAnnouncementDateShort,
} from '../Admin/Announcements/announcementHelpers';
import './PublicAnnouncementPage.css';

function PublicAnnouncementPage() {
  const { id } = useParams();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!id) return;
    let cancelled = false;
    setLoading(true);
    setNotFound(false);
    announcementsPublicApi
      .getOne(id)
      .then((data) => {
        if (!cancelled) setItem(data);
      })
      .catch((err) => {
        if (cancelled) return;
        if (err.response?.status === 404) setNotFound(true);
        setItem(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [id]);

  if (!id) {
    return <Navigate to="/news-calendar" replace />;
  }

  if (loading) {
    return (
      <main className="public-announcement-page">
        <div className="public-announcement-inner">
          <p className="public-announcement-loading">Loading…</p>
        </div>
      </main>
    );
  }

  if (notFound || !item || !announcementId(item)) {
    return (
      <main className="public-announcement-page">
        <div className="public-announcement-inner">
          <Link to="/news-calendar" className="public-announcement-back">
            ← News &amp; School Calendar
          </Link>
          <h1 className="public-announcement-title">Announcement not found</h1>
          <p className="public-announcement-muted">This announcement may have been removed.</p>
          <Link to="/news-calendar" className="btn btn-primary public-announcement-cta">
            Back to News &amp; Calendar
          </Link>
        </div>
      </main>
    );
  }

  const body = announcementBody(item);
  const dateLabel = formatAnnouncementDateShort(announcementDateInputValue(item));

  return (
    <main className="public-announcement-page">
      <div className="public-announcement-inner">
        <Link to="/news-calendar" className="public-announcement-back">
          ← News &amp; School Calendar
        </Link>
        <article>
          <p className="public-announcement-meta">
            <time dateTime={announcementDateInputValue(item) || undefined}>{dateLabel}</time>
          </p>
          <h1 className="public-announcement-title">{item.title || 'Announcement'}</h1>
          {body ? (
            <div className="public-announcement-body">{body}</div>
          ) : (
            <p className="public-announcement-muted">No additional details.</p>
          )}
        </article>
      </div>
    </main>
  );
}

export default PublicAnnouncementPage;
